export function validateSignatureFile(file: Pick<File, 'type' | 'size'>): void {
    if (!['image/png', 'image/jpeg'].includes(file.type) || file.size <= 0 || file.size > 5 * 1024 * 1024) {
        throw new Error('Chọn ảnh PNG hoặc JPEG không quá 5 MB.');
    }
}

export function signatureImageFromDataUrl(value: string): string {
    const match = /^data:image\/(png|jpeg);base64,([A-Za-z0-9+/]+={0,2})$/.exec(value);
    if (!match || match[2].length % 4 !== 0) throw new Error('Ảnh chữ ký không hợp lệ.');
    const bytes = atob(match[2]);
    const png = bytes.startsWith('\x89PNG\r\n\x1a\n');
    const jpeg = bytes.startsWith('\xff\xd8\xff');
    if ((match[1] === 'png' && !png) || (match[1] === 'jpeg' && !jpeg)) {
        throw new Error('Nội dung ảnh không khớp định dạng PNG/JPEG.');
    }
    return match[2];
}

export function readSignatureImage(file: File): Promise<string> {
    validateSignatureFile(file);
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = () => reject(new Error('Không đọc được ảnh chữ ký.'));
        reader.onload = () => {
            try { resolve(signatureImageFromDataUrl(String(reader.result))); }
            catch (error) { reject(error); }
        };
        reader.readAsDataURL(file);
    });
}
